var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"serviceNas"},[_c('a',{attrs:{"href":"https://glhs.quickconnect.cn/","target":"_blank"}},[_vm._v("点击打开Nas网络存储服务")])])}]

export { render, staticRenderFns }